"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const phases = [{
  step: "03",
  name: "Match emerging talent",
  description: "We connect motivated youth with meaningful work opportunities, ensuring every placement drives measurable impact for your organization."
}, {
  step: "04",
  name: "Support delivery",
  description: "We provide hands-on guidance and expert oversight throughout the project lifecycle to guarantee success for both the organization and the talent."
}, {
  step: "05",
  name: "Create employability outcomes",
  description: "We transform project success into concrete employment results, building lasting internal capability and clear career pathways for emerging talent."
}];
export default function Model() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="19508" id="how-the-model-works" className="bg-white py-32 md:py-44">
      
    </section>;
}